import React from 'react';
import OverPack from 'rc-scroll-anim/lib/ScrollOverPack';
import { getChildrenToRender } from '../../utils';
/* replace-start */
import './index.less';
/* replace-end */
class Feature23 extends React.PureComponent {
  render() {
    const { ...tagProps } = this.props;
    const { dataSource } = tagProps;
    delete tagProps.dataSource;
    delete tagProps.isMobile;
    const childData = dataSource.itemWrapper || dataSource.childWrapper;

    return (
      <OverPack {...tagProps} {...dataSource.wrapper}>
        {childData.children.map(getChildrenToRender)}
      </OverPack>
    );
  }
}
export default Feature23;
